import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function GenericNextSteps() {
  const contrasts = [{
    reader: 'Reader recognized a real problem',
    step: 'Homepage'
  }, {
    reader: 'Reader wants to apply one idea',
    step: 'Newsletter'
  }, {
    reader: 'Reader may need help',
    step: 'Resource page'
  }, {
    reader: 'Reader is not ready for a sales call',
    step: 'Broad "work with me"'
  }];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative border-t border-gray-200" data-id="element-186" data-mp="7t5qojf6dpqt">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-187" data-mp="3pzae8tohlqiz">
        <PathThread data-id="element-188" data-mp="3q0v5oafi8tcm" />
      </div>

      <div className="text-center mb-20" data-id="element-189" data-mp="3uwtsvup3k5bg">
        <Reveal data-id="element-190" data-mp="3uxvcink6i04s">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-191" data-mp="3uzg8mhm55r4r">
            A homepage is{' '}
            <span className="italic text-seaglass" data-id="element-192" data-mp="1t5ywb0n2g23o">not a next step</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-193" data-mp="sujlqx8eo4wv">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-194" data-mp="stqnylrfcpqv">
            <p data-id="element-195" data-mp="osomdya1c1lq">Most book paths are too generic.</p>
            <p data-id="element-196" data-mp="12kv1ri5d64k4">
              A reader gets interested, then lands on the same next step as
              everyone else: homepage, newsletter, resource page, contact form,
              broad "work with me" button, or list of offers.
            </p>
            <p data-id="element-197" data-mp="9wyy1thdncdu">That puts too much work on the reader.</p>
            <p className="font-medium text-navy text-xl" data-id="element-198" data-mp="5uviasnodlmr">
              A serious reader should not have to reverse-engineer your business
              to know what to do next.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} data-id="element-199" data-mp="euim1l3vn3iz">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-gray-100 mb-24 shadow-[0_12px_30px_-15px_rgba(26,40,56,0.15)]" data-id="element-200" data-mp="etz5o8tvkn72">
          <div className="grid gap-6" data-id="element-201" data-mp="1qapc9t27nh17">
            {contrasts.map((item, idx) => <div key={idx} className="flex flex-col md:flex-row items-center justify-between gap-4 p-5 bg-paper-dark rounded-2xl border border-gray-100" data-id="element-202" data-mp="1qcjo8hvi7yt5" data-mpi={idx}>
              
                <div className="text-navy font-semibold text-center md:text-left flex-1" data-id="element-203" data-mp="22b5ixu50w2vt">
                  {item.reader}
                </div>

                {/* Broken / thinning connector — the mismatch */}
                <div className="hidden md:flex items-center w-28 flex-shrink-0" data-id="element-204" data-mp="2ca4txjd9galz">
                  <div className="w-2 h-2 rounded-full bg-seaglass" data-id="element-205" data-mp="1eogusqpf7e6r"></div>
                  <div className="flex-1 border-t-2 border-dashed border-gray-300" data-id="element-206" data-mp="1jlh3zahkgx23"></div>
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-207" data-mp="1oktpnrwpby33"></div>
                </div>

                <div className="text-gray-400 font-serif text-lg text-center md:text-right flex-1 line-through decoration-gray-300/70 decoration-1" data-id="element-208" data-mp="1tck52cahxc1d">
                  {item.step}
                </div>
              </div>)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.3} data-id="element-209" data-mp="10to9fbmun3s9">
        <div id="quick-check-2" className="scroll-mt-32" data-id="element-210" data-mp="tbygb9001g4z">
          <ReaderPathCheck questionId="q1.intent.nextAsk" checkLabel="Quick Check · 2 of 8" confirmationText="Saved." data-id="element-211" data-mp="tbgnkmcjpk1t" />
          
        </div>
      </Reveal>
    </section>;
}